import { createContext, useContext } from "react";

/**
 * Kontekst warstwy „nad oknem modalnym” [polecenie właściciela 2026-10-01: „widok wysuwanej karty jest pod modalem”].
 *
 * Osobny moduł, bo czytają go DWIE grupy: szuflada (SideDrawer) i pola z listą w portalu (DatePicker, DateTimePicker,
 * TimePicker, MultiSelectCombo). Pola nie mogą importować całej szuflady (arkusz, portal) tylko po to, żeby
 * odczytać jedną wartość.
 *
 * Wartość true daje okno modalne (`SzufladyNadModalem` w SideDrawer.js) i szuflada stojąca nad oknem (przekazuje swoją
 * warstwę treści i stopce). Domyślnie false — zwykła strona nic nie widzi i nic się na niej nie zmienia.
 */
export const WarstwaNadModalem = createContext(false);

/**
 * Warstwa pola z listą w portalu: jawny prop `nadModalem` (true ALBO false) wygrywa, a gdy go nie podano, decyduje
 * kontekst. Bez tego szuflada otwarta z karty BEZ propsa sama stawała na --z-drawer-over-modal (10011), a kalendarz
 * lub lista jej pola zostawały na 10001 lub 10000 — POD jej panelem, nie do kliknięcia.
 */
export function useWarstwaNadModalem(jawny) {
    const zKontekstu = useContext(WarstwaNadModalem);
    return typeof jawny === "boolean" ? jawny : zKontekstu;
}
